import { StationAccessType } from './station-access-type.model';
import { Connector } from './connector.model';
import { SpecialUserModel } from './special-user-model.model';
import { StationState } from './station-state.model';
import { TranslateService } from '@ngx-translate/core';
import { StationPlugType } from './station-plug-type.model';

export class HubjectModel {
  ID: string;
  PricingProductId: string;
  IsEnabled: boolean;
}

export class ConnectorModel {
  DeviceId: string;
  Id: number;
  Name: string;
  Description: string;
  State: string;
  StateText: string;
  AccessType: StationAccessType;
  AccessTypeText: string;
  EnergyPrice: number;
  EnergyPriceText: string;
  ParkingPrice: number;
  ParkingPriceText: string;
  Data: Connector;
  IsLastConnector: boolean;
  SearchString: string;
  SpecialUserModels: SpecialUserModel[];
  PlugType: StationPlugType;
  MaxPower: number;
  ActivePower: number;
  StationId: string;
  AllowEditing: boolean;
  IsAutoChargeEnabled: boolean;
  Hubject: HubjectModel;

  constructor(
    private connector: Connector,
    private stationId: string,
    public translate: TranslateService
  ) {
    this.Data = connector;
    this.StationId = stationId;
    this.initValues();
  }

  private initValues() {
    this.DeviceId = this.Data.DeviceID;
    this.Id = this.Data.Id;
    this.Name = this.Data.Name;
    this.Description = this.Data.Description;
    this.PlugType = this.Data.PlugType;
    this.MaxPower = this.Data.MaxPower;
    this.ActivePower = this.Data.ActivePower;

    this.State = StationState[this.Data.State];
    this.translate
      .get(StationState[this.Data.State])
      .subscribe((res: string) => {
        this.StateText = res;
      });

    this.AccessType = this.Data.AccessType;
    this.translate
      .get(StationAccessType[this.Data.AccessType])
      .subscribe((res: string) => {
        this.AccessTypeText = res;
      });

    this.EnergyPrice = this.Data.Price.EnergyPrice;
    this.EnergyPriceText =
      this.Data.Price.EnergyPrice.toFixed(2) + ' ' + this.Data.Price.Currency;
    this.ParkingPrice = this.Data.Price.ParkingPrice;
    this.ParkingPriceText =
      this.Data.Price.ParkingPrice.toFixed(2) + ' ' + this.Data.Price.Currency;

    this.IsAutoChargeEnabled = this.Data.IsAutoChargeEnabled;

    this.Hubject = new HubjectModel();
    this.Hubject.ID = this.Data.Hubject.ID;
    this.Hubject.IsEnabled = this.Data.Hubject.IsEnabled;
    this.Hubject.PricingProductId = this.Data.Hubject.PricingProductId;
  }

  public discardChanges() {
    this.initValues();
  }
}
